import { Route, Routes as RoutesContainer } from 'react-router';

import { Error403 } from '../index';

const Routes = () => {
  return (
    <RoutesContainer>
      <Route exact path='/403' element={<Error403 />} />
    </RoutesContainer>
  );
};
export default Routes;
